
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Carlos Martínez',
      location: 'Barcelona',
      text: 'Vendí mi coche siniestrado en menos de 48 horas. Proceso súper rápido y el mejor precio que encontré en Barcelona. Totalmente recomendable.',
      rating: 5,
      avatar: 'https://public.readdy.ai/ai/img_res/c9778e6026bd76ab110946d7837c5907.jpg'
    },
    {
      name: 'Laura Sánchez',
      location: 'Badalona',
      text: 'Excelente servicio. Mi coche llevaba años sin ITV y no sabía qué hacer. Me lo recogieron gratis y pagaron al instante. Muy profesionales.',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=professional%20spanish%20woman%20portrait%20smiling%20satisfied%20customer%20clean%20white%20background%20headshot%20photography%20natural%20lighting%20business%20casual%20style&width=200&height=200&seq=avatar002&orientation=squarish'
    },
    {
      name: 'Miguel Rodríguez',
      location: 'Hospitalet',
      text: 'Trato cercano y honesto. Me explicaron todo el proceso y cumplieron con lo prometido. La mejor opción para vender tu coche en Barcelona.',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=professional%20spanish%20mature%20man%20portrait%20smiling%20happy%20customer%20clean%20white%20background%20headshot%20photography%20natural%20lighting%20business%20style&width=200&height=200&seq=avatar003&orientation=squarish'
    },
    {
      name: 'Ana García',
      location: 'Sabadell',
      text: 'Mi coche estaba averiado y necesitaba venderlo urgente. En 24 horas tenía la oferta y en 3 días el dinero en mi cuenta. Increíble.',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=professional%20spanish%20young%20woman%20portrait%20smiling%20satisfied%20customer%20clean%20white%20background%20headshot%20photography%20natural%20lighting%20casual%20style&width=200&height=200&seq=avatar004&orientation=squarish'
    },
    {
      name: 'Jordi Puig',
      location: 'Terrassa',
      text: 'Servicio impecable de principio a fin. Muy transparentes con el precio y sin sorpresas. Volveré a confiar en ellos sin duda.',
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=professional%20catalan%20man%20portrait%20smiling%20happy%20customer%20clean%20white%20background%20headshot%20photography%20natural%20lighting%20business%20casual%20style&width=200&height=200&seq=avatar005&orientation=squarish'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-[#1a2332] text-white px-4 py-2 rounded-full mb-4">
            <i className="ri-star-fill text-[#ff6b35] mr-2"></i>
            <span className="text-sm font-semibold">Opiniones Reales</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-[#1a2332] mb-4">
            Más de 2.500 Clientes Satisfechos en Barcelona
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
          {testimonials.slice(0, 3).map((testimonial, index) => (
            <div key={index} className="bg-[#e8f0f7] rounded-2xl p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-center mb-4">
                <img 
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover mr-4"
                />
                <div>
                  <h4 className="font-bold text-[#1a2332]">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              <div className="flex items-center justify-center mb-4">
                <i className="ri-double-quotes-l text-5xl text-[#1a2332]/20"></i>
              </div>
              <p className="text-[#1a2332] text-base leading-relaxed mb-4">{testimonial.text}</p>
              <div className="flex gap-1">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#ff6b35]"></i>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          <div className="md:col-span-3 relative rounded-2xl overflow-hidden h-64">
            <img 
              src={testimonials[3].avatar}
              alt={testimonials[3].name}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a2332]/90 via-[#1a2332]/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <h4 className="font-bold text-lg mb-1">{testimonials[3].name}</h4>
              <p className="text-sm text-white/80 mb-2">{testimonials[3].location}</p>
              <p className="text-sm leading-relaxed mb-3">{testimonials[3].text}</p>
              <div className="flex gap-1">
                {[...Array(testimonials[3].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#ff6b35]"></i>
                ))}
              </div>
            </div>
          </div>

          <div className="md:col-span-2 flex flex-col gap-6">
            <div className="bg-[#e8f0f7] rounded-2xl p-6 flex-1">
              <div className="flex items-center justify-center mb-3">
                <i className="ri-double-quotes-l text-3xl text-[#1a2332]/20"></i>
              </div>
              <p className="text-[#1a2332] text-sm leading-relaxed mb-3">{testimonials[4].text}</p>
              <div className="flex items-center">
                <img 
                  src={testimonials[4].avatar}
                  alt={testimonials[4].name}
                  className="w-10 h-10 rounded-full object-cover mr-3"
                />
                <div>
                  <h4 className="font-bold text-[#1a2332] text-sm">{testimonials[4].name}</h4>
                  <p className="text-xs text-gray-600">{testimonials[4].location}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
